var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hoc-content-overlay",class:{'hoc-new-ticket-overlays': _vm.ticketTypesOverlays.includes(_vm.overlay)},on:{"click":_vm.close}},[_c(_vm.overlay,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }